import React from "react";
import CopyEmailButton from "./CopyEmailButton";
import { PavementSides } from "./Panot";
import { PillLink } from "./ProjectShowcase";
import { trackAction } from "./PageAnalytics";
import { intro } from "../../data/homepage";

// One reading sequence on every width: what kind of designer, how, then the
// one primary action (copy the address) and the archive link. The work
// follows straight after, so there is no button pointing down to it.
//
// Around it, Barcelona pavement on either side of the title and subtitle.
// It is decoration and sits outside the reading order.

function Hero() {
  return (
    <section className="pf-intro pf-shell" aria-labelledby="intro-title">
      <PavementSides id="pf-panot-hero" />
      <h1 id="intro-title" className="pf-intro__title">
        {intro.title}
      </h1>
      <p className="pf-intro__subtitle">{intro.subtitle}</p>
      <div className="pf-intro__actions">
        <CopyEmailButton source="intro" variant="primary" />
        <PillLink to="/work" onClick={() => trackAction("open_work", "intro")}>
          All work
        </PillLink>
      </div>
    </section>
  );
}

export default Hero;
